export default __webpack_public_path__ + "static/media/photo.fb01915e.svg";